import styled from "styled-components";

export const ContainerReports = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  iframe {
    grid-area: iframe;
    width: 100%;
    height: 90vh;
  }
`;

export const ContainerIframe = styled.div`
  margin-top: 0px;
  margin-left: 0px;
`;
